/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_BusyInputs */

const cs_documents_busy = /** @type {(inputs: Documents_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpracovává se…`)
};

const en_documents_busy = /** @type {(inputs: Documents_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still processing…`)
};

/**
* | output |
* | --- |
* | "Still processing…" |
*
* @param {Documents_BusyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_busy = /** @type {((inputs?: Documents_BusyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_BusyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_busy(inputs)
	return cs_documents_busy(inputs)
});